exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".report-widget-edit-modal .modal-dialog {\n  width: 80%;\n}", ""]);

